var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncorrectAnswer({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.955078 0.955078L11.9551 11.9551",
    stroke: "#B9382A",
    strokeWidth: 2.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.955078 11.9551L11.9551 0.955078",
    stroke: "#B9382A",
    strokeWidth: 2.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncorrectAnswer);
export default __webpack_public_path__ + "static/media/incorrect-answer.b199d93469b4ed742ecab64631fd5761.svg";
export { ForwardRef as ReactComponent };